document.querySelectorAll('.newsletters-filter').forEach((filter) => {
  filter.addEventListener('change', function filterChange() {
    this.form.submit();
  });
});
